<template>
    <ol class="breadcrumb my-auto text-muted">
        <li class="breadcrumb-item" :class="[stepStyle(STATUS_DRAFT).text, {'active': !billable || this.isActive(STATUS_DRAFT)}]">
            <span>{{ trans('general.page.space_billing.status.draft') }}</span>
        </li>
        <li class="breadcrumb-item" :class="[stepStyle(STATUS_OPEN).text, {'active': this.isActive(STATUS_OPEN)}]">
            <span>{{ trans('general.page.space_billing.status.open') }}</span>
        </li>
        <li class="breadcrumb-item" :class="[stepStyle(STATUS_PAID).text, {'active': this.isActive(STATUS_PAID)}]">
            <span>{{ trans('general.page.space_billing.status.paid') }}</span>
        </li>
        <li class="breadcrumb-item active" :class="[stepStyle(STATUS_CANCELED).text]" v-if="this.isActive(STATUS_CANCELED)" >
            <span>{{ trans('general.page.space_billing.status.canceled') }}</span>
        </li>
    </ol>
</template>

<script>
import {
    DEFAULT_STATUS_STYLES,
    STATUS_APPROVED,
    STATUS_CANCELED,
    STATUS_DRAFT,
    STATUS_OPEN,
    STATUS_PAID,
} from "../../../services/SpaceBillingContants";

export default {
    name: "BillingBreadcrumb",
    props: {
        billable: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            STATUS_DRAFT,
            STATUS_OPEN,
            STATUS_PAID,
            STATUS_CANCELED,
            STATUS_APPROVED,
            DEFAULT_STATUS_STYLES,
            statuses: [
                STATUS_DRAFT,
                STATUS_OPEN,
                STATUS_PAID,
                STATUS_CANCELED,
                STATUS_APPROVED,
            ]
        }
    },
    methods: {
        isActive(status) {
            return status === this.billable?.status;
        },
        stepStyle(status) {
            return this.isActive(status) ? DEFAULT_STATUS_STYLES[status] : DEFAULT_STATUS_STYLES.draft;
        }
    }
}
</script>

<style scoped>
.breadcrumb-item.active{
    font-weight: bold;
    font-style: italic;
}
</style>
